import { render, staticRenderFns } from "./ChangeCard.vue?vue&type=template&id=3b8729bc&"
import script from "./ChangeCard.vue?vue&type=script&lang=ts&"
export * from "./ChangeCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports